export default __webpack_public_path__ + "assets/images/d2ae7b70e608b89cb4ec96900527d968.svg";